<template>
  <v-card
    class="rounded-xl text-left d-flex flex-column"
    outlined
    :style="{
      borderColor: cardClicked ? cardBorderColor : ''
    }"
    width="280px"
    :disabled="disabled"
    @click="$emit('card-click')"
  >
    <v-card-title
      class="text-body-1 grey--text text--darken-4 font-weight-bold pb-2"
      style="background: white !important;"
    >
      {{ title }}
    </v-card-title>
    <v-card-subtitle
      class="text-body-2 grey--text text--darken-4 pb-2"
    >
      <div
        v-if="subtitle"
        class="mb-2"
      >
        {{ subtitle }}
      </div>
      <div
        class="text-body-1 font-weight-bold"
        :class="Number(price) === 0 ? 'primary-grey--text' : 'primary--text'"
      >
        {{ Number(price) === 0 ? 'Free' : formatCurrency(price, 0) }}
        <span v-if="frequency && Number(price) !== 0">
          /{{ frequency }}
        </span>
      </div>
    </v-card-subtitle>
    <v-card-text
      v-if="features.length"
      class="pb-0"
    >
      <v-divider />
      <v-list>
        <v-list-item
          v-for="(feature, index) in features"
          :key="index"
          class="pa-0 ma-0"
        >
          <v-list-item-content
            class="pa-0 ma-0"
          >
            <v-list-item-title
              class="d-flex align-start"
            >
              <v-icon
                small
                color="primary"
                left
              >
                mdi-check
              </v-icon>
              <span class="text-caption grey--text text--darken-4 text-wrap">
                {{ feature }}
              </span>
            </v-list-item-title>
          </v-list-item-content>
        </v-list-item>
      </v-list>
    </v-card-text>
    <v-card-actions class="d-flex flex-column mt-auto">
      <v-btn
        v-for="(button, index) in buttons"
        :key="index"
        block
        :color="cardClicked ? button.color || COLORS.primary : 'grey lighten-3'"
        class="text-body-2 font-weight-bold mb-2 white--text flex-grow-1 mx-1"
        :class="cardClicked ? 'white--text' : 'primary-grey--text'"
        :disabled="disabled"
        @click="button.action"
      >
        {{ button.buttonText }}
      </v-btn>
    </v-card-actions>
  </v-card>
</template>

<script>
import { formatCurrency } from '@/helpers/formatting';
import { COLORS } from '@/helpers/colors';

export default {
  name: 'PlanCard',

  props: {
    title: {
      type: String,
      required: true,
    },

    subtitle: {
      type: String,
      default: '',
    },

    price: {
      type: Number,
      required: true,
    },

    frequency: {
      type: String,
      default: '',
    },

    features: {
      type: Array,
      default: () => [],
    },

    buttons: {
      type: Array,
      default: () => [],
    },

    cardBorderColor: {
      type: String,
      default: COLORS.primary,
    },

    cardClicked: {
      type: Boolean,
      default: false,
    },

    disabled: {
      type: Boolean,
      default: false,
    },
  },

  data() {
    return {
      COLORS,
    };
  },

  methods: {
    formatCurrency,
  },
};
</script>

<style scoped>
::v-deep .v-list-item {
  min-height: 0;
  padding-top: 5px !important;
  padding-bottom: 5px !important;
}

.text-wrap {
  white-space: normal !important;
  word-break: break-word;
}
</style>
